export const TIMEOUT_GET_PROCESSING_UID = 2000;
